import styled from 'styled-components';
import { theme, toRem } from '../../styles';
import { colors } from '../../styles/colors';

export const StyledExperienceDetails = styled.div`
  .experience-section {
    @media ${theme.mediaQuery.allMobiles} {
      padding: 0 8px;
    }
  }
  hr {
    width: 100%;
    height: 0px;
    color: ${colors.grey5};
    margin: 25px 0;
    @media ${theme.mediaQuery.allMobiles} {
      margin: 22px 0;
    }
  }

  h1 {
    font: normal normal var(--t-title-m-font-weight) ${toRem(60)} / normal var(--t-title-font-family);
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal var(--t-title-m-font-weight) ${toRem(30)} / normal var(--t-title-font-family);
    }
  }

  p,
  div {
    &.t-font-m {
      font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(16)} var(--t-base-font-family);
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
      }
    }
    &.t-font-s {
      font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family);
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family);
      }
    }
    b {
      @media ${theme.mediaQuery.allMobiles} {
        display: block;
      }
    }
    &.subTitle {
      font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family);
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
      }
    }
  }
  .noteText {
    p {
      &:nth-child(1) {
        margin-bottom: 0px;
        @media ${theme.mediaQuery.allMobiles} {
          margin-bottom: 0px;
        }
      }
    }
  }

  .heading-top-margin {
    margin-top: 26px;
  }

  .lr-no-padding {
    padding: 48px 20px !important;
    @media ${theme.mediaQuery.allMobiles} {
      padding: 28px 5px !important;
    }
  }

  .small-h6 {
    font: normal 700 ${toRem(18)} / ${toRem(20)} var(--t-base-font-family) !important;
    @media ${theme.mediaQuery.allMobiles} {
      font: normal 700 ${toRem(14)} / ${toRem(20)} var(--t-base-font-family) !important;
    }
  }

  input[type='checkbox']:checked + .toggle-slider {
    background-color: var(--t-interactive-accent-color);
    border-color: var(--t-interactive-accent-color);
  }
  .m-button-secondary.custom-btn {
    margin-right: 25px !important;
  }

  textarea {
    padding: 10px 15px !important;
    color: var(--t-brand-fg-color) !important;
    caret-color: var(--t-brand-fg-color) !important;
    max-width: 301px;
    max-height: 62px;
    border: 1px solid var(--t-input-fields-bg-color) !important;
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
  }

  .flex-row-desktop {
    @media ${theme.mediaQuery.allMobiles} {
      flex-direction: column !important;
    }
  }

  .mobile-space {
    @media ${theme.mediaQuery.allMobiles} {
      justify-content: space-between !important;
      margin-top: 26px !important;
    }
  }

  .subtext {
    p {
      display: inline;
    }
  }

  input[type='checkbox']:checked + label:before {
    outline: none !important;
  }

  .d-flex-mobile {
    @media ${theme.mediaQuery.allMobiles} {
      justify-content: space-between !important;
    }
    button {
      @media ${theme.mediaQuery.allMobiles} {
        padding: 7px 28px;
      }
      &.m-button-primary {
        @media ${theme.mediaQuery.allMobiles} {
          padding: 8px 28px;
        }
      }
    }
  }

  input[type='checkbox'] + label {
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
    margin-bottom: 15px !important;
  }

  button[aria-label='Continue'] {
    width: 145px;
    padding: 9px 24px !important;
    font: normal normal 700 ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal 700 ${toRem(13)} / ${toRem(17)} var(--t-base-font-family) !important;
      width: 110px;
      height: auto;
      padding: 7px 24px 8px !important;
    }
  }

  .mobile-space {
    button[aria-label='Previous'] {
      width: 145px;
      padding: 8px 24px !important;
      font: normal normal 700 ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal 700 ${toRem(13)} / ${toRem(17)} var(--t-base-font-family) !important;
        width: 110px;
        height: auto;
        padding: 7px 24px 6px !important;
      }
    }
  }
  .row {
    &.dietryref {
      width: 100%;
      max-width: 575px;
    }
  }
`;
